import { useEffect, useRef, useState } from "react";
import "./CommentSection.css";
import AudioPlayer from "./audioPlayer/AudioPlayer";
import { useLocation, useParams } from "react-router-dom";
import { useGlobalContext } from "../../../context/GlobalContext";
// import { formatDateTimeForTimeModal } from "../../../utils/formatDateAndTime"
import VideoMessage from "./videoModal/VideoMessage";
import { useFetchComment } from "features/Setting/Service Request/API/getAllServiceRequest";
import { formatDateAndTime } from "utils/formatDateAndTime";
// import CommentSkeleton from "../../Skeleton/CommentSkeleton"

const CommentSection = ({ commentUser = [] }) => {
  const { grabRefIds, externalComment, setExternalComment, scrollToBottomTrigger, setScrollToBottomTrigger } = useGlobalContext();

  const bottomRef = useRef(null);
  const { serviceRequestId } = useParams();

  const { data: apiResponse, isLoading, isError, error } = useFetchComment({ serviceRequestId });


  const [messageData, setMessageData] = useState([]);
  const [isInitialLoad, setIsInitialLoad] = useState(true);

  // API response ko transform karna
  useEffect(() => {
    if (apiResponse && Array.isArray(apiResponse)) {
      // Transform API data to match your component's format
      const transformedData = apiResponse.map(item => ({
        userName: item.name || "",
        profileImg: item.profileUrl || "",
        time: item.createdAt || new Date().toISOString(),
        title: item.subTitle || "",
        messageType: Array.isArray(item.message) ? item.message.map(m => m.type).join(",") : "",
        message: {
          text: Array.isArray(item.message) ? item.message.find(m => m.type === "Text")?.value || "" : "",
          images: Array.isArray(item.message) ? item.message.filter(m => m.type === "Image").map(m => m.value) : [],
          videos: Array.isArray(item.message) ? item.message.filter(m => m.type === "Video").map(m => m.value) : [],
          audio: Array.isArray(item.message) ? item.message.find(m => m.type === "Audio")?.value || "" : ""
        }
      }));

      setMessageData(transformedData);
    } else if (apiResponse?.data && Array.isArray(apiResponse.data)) {
      // Agar response { data: [] } format mein ho
      const transformedData = apiResponse.data.map(item => ({
        userName: item.name || "",
        profileImg: item.profileUrl || "",
        time: item.createdAt || new Date().toISOString(),
        title: item.subTitle || "",
        messageType: Array.isArray(item.message) ? item.message.map(m => m.type).join(",") : "",
        message: {
          text: Array.isArray(item.message) ? item.message.find(m => m.type === "Text")?.value || "" : "",
          images: Array.isArray(item.message) ? item.message.filter(m => m.type === "Image").map(m => m.value) : [],
          videos: Array.isArray(item.message) ? item.message.filter(m => m.type === "Video").map(m => m.value) : [],
          audio: Array.isArray(item.message) ? item.message.find(m => m.type === "Audio")?.value || "" : ""
        }
      }));

      setMessageData(transformedData);
    } else {
      // Agar koi data nahi hai to empty array set karo
      setMessageData([]);
    }
    
  }, [apiResponse]); // ✅ API response change hone par chalega

  useEffect(() => {
    if (externalComment) {
      // Agar externalComment aaye to transform karo
      const transformedComment = {
        userName: externalComment.name || "",
        profileImg: externalComment.profileUrl || "",
        time: externalComment.createdAt || new Date().toISOString(),
        title: externalComment.subTitle || "",
        messageType: Array.isArray(externalComment.message) ? externalComment.message.map(m => m.type).join(",") : "",
        message: {
          text: Array.isArray(externalComment.message) ? externalComment.message.find(m => m.type === "Text")?.value || "" : "",
          images: Array.isArray(externalComment.message) ? externalComment.message.filter(m => m.type === "Image").map(m => m.value) : [],
          videos: Array.isArray(externalComment.message) ? externalComment.message.filter(m => m.type === "Video").map(m => m.value) : [],
          audio: Array.isArray(externalComment.message) ? externalComment.message.find(m => m.type === "Audio")?.value || "" : ""
        }
      };

      setMessageData(prev => [...prev, transformedComment]);
      setExternalComment(null);
    }
  }, [externalComment, setExternalComment]);

  // useEffect(() => {
  //   if (scrollToBottomTrigger && bottomRef.current) {
  //     bottomRef.current.scrollIntoView({ behavior: "smooth" });
  //     setScrollToBottomTrigger(false);
  //   }
  // }, [messageData, scrollToBottomTrigger, setScrollToBottomTrigger]);

  
  useEffect(() => {
    console.log("scrollToBottomTrigger",scrollToBottomTrigger)
    if (scrollToBottomTrigger && bottomRef.current) {
      const timeoutId = setTimeout(() => {
        bottomRef.current.scrollIntoView({ 
          behavior: "smooth",
          block: "nearest"
        });
      }, 50);
      
      return () => clearTimeout(timeoutId);
    }
  }, [messageData,scrollToBottomTrigger, setScrollToBottomTrigger]);

  function renderCommentText(text) {
    if (!text) return text;

    // Highlight any @word mention, regardless of whether it matches a known user
    const pattern = /@(\S+)/g;

    const parts = [];
    let lastIndex = 0;

    text.replace(pattern, (match, p1, offset) => {
      // Add text before the match
      if (offset > lastIndex) {
        parts.push(text.slice(lastIndex, offset));
      }

      // Add the highlighted mention (without the leading @)
      parts.push(
        <span key={offset} style={{ color: "#3B9DFF", fontWeight: 700 }}>
          {p1}
        </span>
      );

      lastIndex = offset + match.length;
    });

    // Add remaining text
    if (lastIndex < text.length) {
      parts.push(text.slice(lastIndex));
    }

    return parts.length > 0 ? parts : text;
  }

  // Agar loading ho
  if (isLoading) {
    return (
      <div className="commentRef-box" style={{ paddingBottom: "20px", height: "100%" }}>
        <div style={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#8B8B8B",
          fontFamily: "Poppins",
          fontSize: "18px",
          fontWeight: 400,
          lineHeight: "50%",
        }}>
          Loading comments...
        </div>
      </div>
    );
  }

  // Agar error ho
  if (isError) {
    return (
      <div className="commentRef-box" style={{ paddingBottom: "20px", height: "100%" }}>
        <div style={{
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#ff6b6b",
          fontFamily: "Poppins",
          fontSize: "18px",
          fontWeight: 400,
          lineHeight: "100%",
        }}>
          Error loading comments
        </div>
      </div>
    );
  }

  return (
    <div
      className="commentRef-box"
      style={{
        paddingBottom: "20px",
        height: "100%",
      }}
    >
      {messageData && messageData.length > 0 ? (
        <>
          {messageData.map((data, index) => {
            const { message, messageType, userName, profileImg, time, title } = data;

            const getInitials = (name = "") => {
              if (!name) return "";
              const parts = name.trim().split(" ");
              if (parts.length === 1) {
                return parts[0].slice(0, 1).toUpperCase();
              }
              return (parts[0].slice(0, 1) + parts[parts.length - 1].slice(0, 1)).toUpperCase();
            };

            const stringToLightColor = (str = "") => {
              let hash = 0;
              for (let i = 0; i < str.length; i++) {
                hash = str.charCodeAt(i) + ((hash << 5) - hash);
              }
              let color = "#";
              for (let i = 0; i < 3; i++) {
                const value = (hash >> (i * 8)) & 0xff;
                const pastel = Math.floor((value % 106) + 150);
                color += ("00" + pastel.toString(16)).slice(-2);
              }
              return color;
            };

            const darkenColor = (hex, amount = 40) => {
              if (!hex || hex.length < 7) return "rgb(0, 0, 0)";
              let r = parseInt(hex.substr(1, 2), 16);
              let g = parseInt(hex.substr(3, 2), 16);
              let b = parseInt(hex.substr(5, 2), 16);

              r = Math.max(0, r - amount);
              g = Math.max(0, g - amount);
              b = Math.max(0, b - amount);

              return `rgb(${r}, ${g}, ${b})`;
            };

            const bgColor = stringToLightColor(userName);
            const textColor = darkenColor(bgColor, 90);

            return (
              <div key={index} ref={index === messageData.length - 1 ? bottomRef : null}>
                <div
                  className="chat-item"
                  style={{
                    // padding: "0px 0px 16px",
                    // marginTop: "16px",
                    // border:"1px solid red"
                  }}
                >
                  <div className="chat-header">
                    {profileImg ? (
                      <img src={profileImg} alt={userName} className="chat-image" />
                    ) : (
                      <div
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          background: bgColor,
                          color: textColor,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "20px",
                        }}
                      >
                        {getInitials(userName)}
                      </div>
                    )}
                    <p className="chat-name" style={{ display: "flex", gap: "5px",margin:0 }}>
                      {userName}
                      {title && <span style={{ color: "#444444", fontSize: "14px" }}>({title})</span>}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      marginLeft: "58px",
                      gap: "10px",
                      // border:"1px solid red",
                      padding:0
                    }}
                  >
                    {/* Check for Image type messages */}
                    {messageType?.includes("Image") && message.images && message.images.length > 0 && (
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "10px",
                        }}
                      >
                        {message.images.map((img, i) => (
                          <VideoMessage
                            key={i}
                            message={img}
                            fullMessageData={message.images}
                            index={i}
                            type={"Image"}
                          />
                        ))}
                      </div>
                    )}

                    {/* Check for Video type messages */}
                    {messageType?.includes("Video") && message.videos && message.videos.length > 0 && (
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "10px",
                        }}
                      >
                        {message.videos.map((videoUrl, i) => (
                          <VideoMessage
                            key={i}
                            message={videoUrl}
                            fullMessageData={message.videos}
                            index={i}
                            type="Video"
                          />
                        ))}
                      </div>
                    )}

                    {/* Check for Audio type messages */}
                    {messageType?.includes("Audio") && message.audio && (
                      <AudioPlayer src={message.audio} id={index} customStyle={{maxWidth:"400px"}}/>
                    )}

                    {/* Check for Text type messages */}
                    {messageType?.includes("Text") && message.text && (
                      <div
                        style={{
                          wordWrap: "break-word",
                          whiteSpace: "pre-wrap",
                          color: "white",
                        }}
                      >
                        {message.text.startsWith("https") ? (
                          <a
                            href={message.text}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{
                              color: "#007bff",
                              textDecoration: "underline",
                              wordBreak: "break-word",
                            }}
                          >
                            {message.text}
                          </a>
                        ) : (
                          <p style={{margin:0 }} >{renderCommentText(message.text)}</p>
                        )}
                      </div>
                    )}
                  </div>

                  <p className="chat-time" style={{ marginTop: "12px" }}>
                    {/* {formatDateTimeForTimeModal(time)} */}
                    {time && formatDateAndTime(time,false)}
                  </p>
                </div>

                {index < messageData.length - 1 && (
                  <div
                    style={{
                      display: "flex",
                      gap: "8px",
                      overflowX: "hidden",
                    }}
                  >
                    {[...Array(300)].map((_, idx) => (
                      <p
                        style={{
                          minWidth: "7px",
                          borderBottom: "1px solid #444444BF",
                        }}
                        key={idx}
                      ></p>
                    ))}
                  </div>
                )}
              </div>
            );
          })}
        </>
      ) : (
        <p
          style={{
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: "#8B8B8B",
            fontFamily: "Poppins",
            fontSize: "18px",
            fontWeight: 400,
            lineHeight: "100%",
          }}
        >
          No comments available
        </p>
      )}
    </div>
  );
};

export default CommentSection;